// components/CustomScriptInjector/domains.ts — Script domain whitelist validation
import { supabase } from '../../supabase/client';

export const DEFAULT_ALLOWED_DOMAINS = new Set([
    'www.googletagmanager.com',
    'connect.facebook.net',
    'static.ads-twitter.com',
    'analytics.tiktok.com',
    'snackvideo.com',
]);

export const validateDomain = async (src: string, brandId?: string): Promise<boolean> => {
    try {
        const url = new URL(src);
        const domain = url.hostname.toLowerCase();
        if (DEFAULT_ALLOWED_DOMAINS.has(domain)) return true;
        if (brandId) {
            const { data } = await supabase
                .from('pixel_whitelisted_domains')
                .select('id')
                .eq('brandId', brandId)
                .eq('domain', domain)
                .maybeSingle();
            return !!data;
        }
        return false;
    } catch {
        return false;
    }
};
